import config from '../config'

const BASE_URI = config.serverURI
const LOCAL = process.env.NODE_ENV === 'development' ? 'http://localhost:8084' : ''

export default {
  BASE_URI: BASE_URI,
  BATCH_CREATE_ADMIN_ENTITY: (entity) => `${BASE_URI}/admin/bulk/${entity}`,
  CHECK_AUTH: `${BASE_URI}/check-auth`,
  CLONE_TARIFF: id => `${BASE_URI}/tariffs/copy/${id}`,
  CREATE_ADMIN_ENTITY: (entity) => `${BASE_URI}/admin/${entity}`,
  DELETE_ADMIN_ENTITY: (entity, id) => `${BASE_URI}/admin/${entity}/${id}`,
  DO_MERGE: `${BASE_URI}/tariff/merge`,
  EXCHANGE_RATE_FILE_UPLOAD: `${BASE_URI}/file/fx`,
  FIND_PARTIES_USING_LOCATION_FILTER: `${BASE_URI}/parties-by-location`,
  FINANCE_PROFILE_ITEMS: `${BASE_URI}/financial-profile-items`,
  GET_ACCESSORIALS: `${BASE_URI}/accessorial`,
  GET_ADVISORY: `${BASE_URI}/admin/document/search?category=ADVISORY`,
  GET_ADMIN_ENTITY_BY_ID: (entity, id) => `${BASE_URI}/admin/${entity}/${id}`,
  GET_ADMIN_ENTITY_BY_QUICK_SEARCH: (entity, search) => `${BASE_URI}/admin/${entity}/search?quick-search=${search}`,
  GET_ADMIN_ENTITY_BY_FULL_SEARCH: (entity) => `${BASE_URI}/admin/${entity}/search?`,
  GET_ENTITIES: entity => `${BASE_URI}/entities/${entity}`,
  GET_LOCATIONS_NAME_LIKE: name => `${BASE_URI}/locations/${name}`,
  GET_GRAPH: `${BASE_URI}/rate/graph`,
  GET_PARTIES: `${BASE_URI}/parties`,
  GET_QUOTE_EXTERNAL_LINK: `${BASE_URI}/admin/document/search?category=QUOTE_EXTERNAL_LINK`,
  GET_ENTITIES_IN: entity => `${BASE_URI}/entities-in/${entity}`,
  GET_EXPIRING_TARIFFS: (date, days) => `${BASE_URI}/tariffs/expiring/${date}/${days}`,
  GET_WORKBENCH: `${BASE_URI}/workbench`,
  GET_MAI_RATES: `${BASE_URI}/mai-rate`,
  GET_RATES: `${BASE_URI}/rate`,
  GET_RATES_MULTI: `${BASE_URI}/rates`,
  GET_ALL_SERVICE_TYPES: `${BASE_URI}/entities/service-type`,
  GET_LOOKUPS: `${BASE_URI}/tariffs`,
  GET_LOOKUP_RELATIONS: type => `${BASE_URI}/tariffs/relations/${type}`,
  GET_STATS_COUNT: entity => `${BASE_URI}/stats/${entity}/count`,
  GET_STATS_RECENT: entity => `${BASE_URI}/stats/${entity}/recent`,
  GET_TAXES: `${BASE_URI}/tax`,
  MASS_TARIFF_REQUEST_STATUS: `${BASE_URI}/tariffs/status`,
  MASS_UPDATE_TARIFF_RELATIONS: relation => `${BASE_URI}/tariffs/mass-update/${relation}`,
  REFRESH_TOKEN: `${BASE_URI}/refresh-token`,
  JOB: `${BASE_URI}/job`,
  SAVE_LOOKUP_PROFILE: `${BASE_URI}/tariff-profiles`,
  SAVE_LOOKUP_DETAIL: `${BASE_URI}/tariff-details`,
  TARIFF_FILE_UPLOAD: `${BASE_URI}/file/tariff`,
  UPDATE_LOOKUP_PROFILE: id => `${BASE_URI}/tariff-profiles/${id}`,
  UPDATE_ADMIN_ENTITY: (entity, id) => `${BASE_URI}/admin/${entity}/${id}`,
  UPDATE_LINE_CALCULATIONS: id => `${BASE_URI}/tariffs/calculations/${id}`,
  UPDATE_VZ: `${BASE_URI}/vendor-zone-update`,
  SPREADSHEET_CLONE: id => `${BASE_URI}/spreadsheet-descriptor/clone/${id}`,
  SPREADSHEET_CLONE_BY_LEVEL: id => `${BASE_URI}/spreadsheet-descriptor/clone-by-level/${id}`,
  SPREADSHEET_PROPERTIES: type => `${BASE_URI}/spreadsheet-descriptor/properties/${type}`,
  USER_SETTING: (settingCode, userId) => `${BASE_URI}/user-setting/${settingCode}/${userId}`,
  DELETE_USER_SETTINGS: (settingCode) => `${BASE_URI}/user-setting/${settingCode}`,
  GENERATE_REPORT: `${BASE_URI}/report`,
  OPTI_CACHE: `${BASE_URI}/cache`,
  RFP: `${BASE_URI}/rfp`,
  /* The below endpoints are located in the 'WebVerticle' and are seperate from edge endpoints */
  GET_CAPTCHA: `${LOCAL}/captcha`,
  GET_TOKEN: `${LOCAL}/oauth/token`,
  LOGIN: `${LOCAL}/login`,
  HEALTH_CHECK: `${LOCAL}/health-check`,
  HEALTH_CHECK_OPTI: `${LOCAL}/health-check/opti`,
  PWD_RESET: `${LOCAL}/reset-password`
}



// WEBPACK FOOTER //
// ./src/api/endpoints.js